(function(angular){
	'use strict';
	
	angular
		.module('reitServiceModule')
		.service('ReitService', [
			'$http',
			'APP_BASE_PATH',
			'Big',
			'ReitElementFactory',
			ReitServiceFunction
		]);
	
	function ReitServiceFunction(
		$http, 
		APP_BASE_PATH,
		Big,
		ReitElementFactory
	) {
		var service = this;

		var sanitizeTotalSize = function(totalSize) {
			if(typeof(totalSize) === 'number') {
				return totalSize;
			} else {
				return 0;
			}
		};

		service.reitAssetsPromise = function() {
			return ReitElementFactory.getAllReitElements().then(function (reitElementsByStatus) {
				var assets = [];
				var totalSize = 0;

				angular.forEach(reitElementsByStatus.active, function (element) {
					var elementInvestmentSize = Number(Big(element.totalSize));
					var cityAndState = element.city + ', ' + element.state;

					totalSize += elementInvestmentSize;

					assets.push({
						cityAndState: cityAndState,
						imageUrl: element.thumbnailUrl,
						lat: Number(Big(element.lat)),
						lon: Number(Big(element.lon)),
						name: element.name,
						investmentSize: elementInvestmentSize
					});
				});

				return {
					assets: assets,
					totalSize: totalSize
				};
			});
		};
		
		service.offeringAssetsPromise = function(){
			return $http.get(APP_BASE_PATH + '/offerings/funded.json').then(function(response) {
				var assets = [];
				var totalSize = 0;
				
				angular.forEach(response.data, function(offering) {
					totalSize += sanitizeTotalSize(offering.investmentListingSize);

					assets.push({
						cityAndState: offering.cityAndState,
						imageUrl: offering.imageUrl,
						lat: offering.lat,
						lon: offering.lon,
						name: offering.title,
						investmentSize: offering.investmentListingSize
					});
				});
				
				return {
					assets: assets,
					totalSize: totalSize
				};
			});
		};
	}
})(window.angular);